import { useState, useEffect } from "react";
import {Loader} from "rsuite";
import { appCRUD } from "../../../../actions/app";
import moment from "moment";

export const AcademicData = (props) => {
  const { dataId } = props;

  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (dataId) {
      setLoading(true);
      setTimeout(() => {
        appCRUD
          .loadAcademicByid(dataId)
          .then((resp) => {
            setData(resp.data[0]);
          })
          .catch(() => {})
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [dataId]);

  return (
    <div className="card shadow border-red p-3">
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh", // Full viewport height
            overflow: "hidden",
          }}
        >
          <Loader
            backdrop
            size="md"
            speed="slow"
            content="Please wait..."
            vertical
          />
        </div>
      ) : (
        <>
          <div className="row">
            <div className={"col-md-3 col-sm-12"}>
              <p className="h6 fw-bold">Academic Year</p>
            </div>
            <div className={"col-md-1 col-sm-12"}>
              <p className="h6 fw-bold">:</p>
            </div>
            <div className={"col-md-8 col-sm-12"}>
              <p className="h6">{data?.name}</p>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className={"col-md-3 col-sm-12"}>
              <p className="h6 fw-bold">Start Date</p>
            </div>
            <div className={"col-md-1 col-sm-12"}>
              <p className="h6 fw-bold">:</p>
            </div>
            <div className={"col-md-8 col-sm-12"}>
              <p className="h6">
                {moment(data?.start_date).format("ddd, DD MMM YYYY")}
              </p>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className={"col-md-3 col-sm-12"}>
              <p className="h6 fw-bold">End Date</p>
            </div>
            <div className={"col-md-1 col-sm-12"}>
              <p className="h6 fw-bold">:</p>
            </div>
            <div className={"col-md-8 col-sm-12"}>
              <p className="h6">
                {moment(data?.end_date).format("ddd, DD MMM YYYY")}
              </p>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className={"col-md-3 col-sm-12"}>
              <p className="h6 fw-bold">Status</p>
            </div>
            <div className={"col-md-1 col-sm-12"}>
              <p className="h6 fw-bold">:</p>
            </div>
            <div className={"col-md-8 col-sm-12"}>
              <p className="h6">
                {data?.is_active ? (
                  <span className="badge badge-soft-success badge-border">
                    {"Active"}
                  </span>
                ) : (
                  <span className="badge badge-soft-danger badge-border">
                    {"Inactive"}
                  </span>
                )}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
